import { connect } from 'react-redux';
import LaporanEkskul from '../../../views/Student/ekskul/LaporanEkskul.student.view';
import { getStudent } from '../../../states/thunks/student.thunk';


function mapDispatchToProps(dispatch) {
  return {
    handleGetStudent: () => dispatch(getStudent()),
  };
}

export default connect(null, mapDispatchToProps)(LaporanEkskul);


